import {Card, CardActions, CardContent, Container, Typography} from '@mui/material';
import { useCookie } from "react-use";
import {Link} from "react-router";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UnauthorizedPage = () => {

    useTitle(t`Unauthorized`);
    
    const [loggedIn, , removeCookie] = useCookie('logged_in');
    if (loggedIn) {
        removeCookie()
    }

    return (
        <Container maxWidth='lg'>
            <Card
                sx={{
                    backgroundColor: '#ece9e9',
                    mt: '2rem',
                    height: '15rem',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <CardContent>
                    <Typography
                        variant='h2'
                        component='h1'
                        sx={{color: '#1f1e1e', fontWeight: 500}}
                    >
                        <Trans>Unauthorized Page</Trans>
                    </Typography>
                </CardContent>
                <CardActions
                    sx={{
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Link to="/"><Trans>Go Home</Trans></Link>
                    <Link to="/login"><Trans>Go Login</Trans></Link>
                </CardActions>
            </Card>
        </Container>
    );
};

export default UnauthorizedPage;
